export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13666.01a21e0d.jpg";